import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/spsummoning';

/** 状況 `spsummoning_plain`（組み立ては `../fx/spsummoning.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'spsummoning_plain', role: 'effect', ...spec }, 'spsummoning_plain_effect.js');
